import {
  GET_CHART_OF_ACCOUNTS_TEMPLATES_FAILURE,
  GET_CHART_OF_ACCOUNTS_TEMPLATES_REQUEST,
  GET_CHART_OF_ACCOUNTS_TEMPLATES_SUCCESS,
  FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_REQUEST,
  FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_SUCCESS,
  FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_FAILURE,
  FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_REQUEST,
  FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_SUCCESS,
  FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_FAILURE,
  SAVE_CHART_OF_ACCOUNTS_TEMPLATE_REQUEST,
  SAVE_CHART_OF_ACCOUNTS_TEMPLATE_SUCCESS,
  SAVE_CHART_OF_ACCOUNTS_TEMPLATE_FAILURE,
  SAVE_CHART_OF_ACCOUNTS_REQUEST,
  SAVE_CHART_OF_ACCOUNTS_SUCCESS,
  SAVE_CHART_OF_ACCOUNTS_FAILURE,
  CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_REQUEST,
  CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_SUCCESS,
  CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_FAILURE,
  UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_REQUEST,
  UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_SUCCESS,
  UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_FAILURE,
  UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_REQUEST,
  UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_SUCCESS,
  UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_FAILURE,
} from './constants';
import {
  ChartOfAccountsAction,
  ChartOfAccountsState,
  FetchChartOfAccountsTemplatesSuccessAction,
  FetchChartOfAccountsByCountrySuccessAction,
  FetchChartOfAccountsForOrganisationSuccessAction,
} from './types';

const initialState: ChartOfAccountsState = {
  loading: false,
  chartOfAccountsTemplates: null,
  selectedCountryAccounts: undefined,
};

export const chartOfAccountsReducer = (
  state = initialState,
  action: ChartOfAccountsAction
): ChartOfAccountsState => {
  switch (action.type) {
    // Request group
    case GET_CHART_OF_ACCOUNTS_TEMPLATES_REQUEST:
      return {
        ...state,
        loading: true,
        chartOfAccountsTemplates: null,
      };
    case FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_REQUEST:
    case FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_REQUEST:
    case SAVE_CHART_OF_ACCOUNTS_TEMPLATE_REQUEST:
    case SAVE_CHART_OF_ACCOUNTS_REQUEST:
    case CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_REQUEST:
    case UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_REQUEST:
    case UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_REQUEST:
      return handleRequest(state);

    case GET_CHART_OF_ACCOUNTS_TEMPLATES_SUCCESS:
      return handleGetChartOfAccountsTemplatesSuccess(
        state,
        action as FetchChartOfAccountsTemplatesSuccessAction
      );

    case FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_SUCCESS:
      return handleFetchChartOfAccountsByCountrySuccess(
        state,
        action as FetchChartOfAccountsByCountrySuccessAction
      );

    case FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_SUCCESS:
      return handleFetchChartOfAccountsForOrganisationSuccess(
        state,
        action as FetchChartOfAccountsForOrganisationSuccessAction
      );

    // Failure + generic completion group
    case GET_CHART_OF_ACCOUNTS_TEMPLATES_FAILURE:
    case FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_FAILURE:
    case FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_FAILURE:
    case SAVE_CHART_OF_ACCOUNTS_TEMPLATE_SUCCESS:
    case SAVE_CHART_OF_ACCOUNTS_TEMPLATE_FAILURE:
    case SAVE_CHART_OF_ACCOUNTS_SUCCESS:
    case SAVE_CHART_OF_ACCOUNTS_FAILURE:
    case CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_SUCCESS:
    case CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_FAILURE:
    case UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_SUCCESS:
    case UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_FAILURE:
    case UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_SUCCESS:
    case UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_FAILURE:
      return handleFailure(state);

    default:
      return state;
  }
};

function handleGetChartOfAccountsTemplatesSuccess(
  state: ChartOfAccountsState,
  action: FetchChartOfAccountsTemplatesSuccessAction
): ChartOfAccountsState {
  return {
    ...state,
    loading: false,
    chartOfAccountsTemplates: action.payload.templates,
  };
}

function handleFetchChartOfAccountsByCountrySuccess(
  state: ChartOfAccountsState,
  action: FetchChartOfAccountsByCountrySuccessAction
): ChartOfAccountsState {
  const { countryId, chartOfAccounts } = action.payload;
  const accountsArray: any[] = Array.isArray(chartOfAccounts)
    ? chartOfAccounts
    : chartOfAccounts?.accounts ?? chartOfAccounts?.chartOfAccounts ?? [];

  return {
    ...state,
    loading: false,
    selectedCountryAccounts: {
      countryId,
      accounts: accountsArray,
    },
  };
}

function handleFetchChartOfAccountsForOrganisationSuccess(
  state: ChartOfAccountsState,
  _action: FetchChartOfAccountsForOrganisationSuccessAction
): ChartOfAccountsState {
  // Organisation-level chart of accounts are stored on the organisation object
  // in the organisation store; this reducer intentionally leaves state unchanged.
  return {
    ...state,
    loading: false,
  };
}

function handleRequest(state: ChartOfAccountsState): ChartOfAccountsState {
  return {
    ...state,
    loading: true,
  };
}

function handleFailure(state: ChartOfAccountsState): ChartOfAccountsState {
  return {
    ...state,
    loading: false,
  };
}
